export const blockIconsAudioandvideoMicNew = (
	<span className='material-symbols-outlined'>mic</span>
);
